var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "act_view"
  }, /*#__PURE__*/React.createElement("g", {
    id: "act_view_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5415 14.9758C13.4249 14.9758 14.141 14.2596 14.141 13.3762C14.141 12.4928 13.4249 11.7766 12.5415 11.7766C11.658 11.7766 10.9419 12.4928 10.9419 13.3762C10.9419 14.2596 11.658 14.9758 12.5415 14.9758Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5414 8.70032C9.96323 8.70032 7.86572 10.7978 7.86572 13.376C7.86572 15.9542 9.96323 18.0517 12.5414 18.0517C15.1196 18.0517 17.2171 15.9542 17.2171 13.376C17.2171 10.7978 15.1196 8.70032 12.5414 8.70032ZM12.5414 16.4111C10.8678 16.4111 9.50631 15.0496 9.50631 13.376C9.50631 11.7024 10.8678 10.3409 12.5414 10.3409C14.215 10.3409 15.5765 11.7024 15.5765 13.376C15.5765 15.0496 14.215 16.4111 12.5414 16.4111Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.4688 11.5855C22.0333 10.9167 20.8043 9.1997 18.8039 7.70402C16.7762 6.18787 14.6615 5.41907 12.5184 5.41907C10.3784 5.41907 8.26185 6.18578 6.22747 7.69782C4.21818 9.19121 2.97939 10.906 2.54002 11.574C1.81999 12.6686 1.81999 14.0832 2.54002 15.1779C2.97939 15.8459 4.21818 17.5607 6.22747 19.0541C8.26185 20.5662 10.3784 21.3329 12.5184 21.3329C15.813 21.3329 18.4623 19.4958 20.1046 17.9548C20.435 17.6448 20.4515 17.1258 20.1415 16.7954C19.8315 16.4649 19.3124 16.4485 18.982 16.7585C17.5556 18.0969 15.2764 19.6923 12.5183 19.6923C8.53555 19.6923 5.23369 16.288 3.91057 14.2764C3.55078 13.7294 3.55078 13.0226 3.91057 12.4756C5.23369 10.4641 8.53555 7.05974 12.5183 7.05974C16.501 7.05974 19.7827 10.4673 21.094 12.4808C21.4481 13.0246 21.4481 13.7274 21.094 14.2712C20.8468 14.6509 20.9541 15.159 21.3337 15.4062C21.7133 15.6534 22.2216 15.5462 22.4688 15.1665C23.1771 14.0788 23.1771 12.6731 22.4688 11.5855Z",
    fill: "#ffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActView);
export default __webpack_public_path__ + "static/media/act_view.d9222bfedc9c4ba086b56a3fe2c5037d.svg";
export { ForwardRef as ReactComponent };